import React from 'react';
import { useTheme } from 'styled-components';

import { getColor } from '../../V2/Elements/Icons/helpers.ts';
import type { IIcon } from './types.ts';

const Icon = React.forwardRef<SVGSVGElement | null, IIcon>(function Icon({ size = 24, alt, color, className, onClick }, ref) {
  const theme = useTheme();
  const fillColor = React.useMemo(() => getColor({ color, alt, theme }), [color, alt, theme]);
  return (
    <svg ref={ref} onClick={onClick} width={size} height={size} viewBox='0 0 17 24' className={className} fill={fillColor}>
      <g>
        <g transform='translate(-808.000000, -263.000000)'>
          <g transform='translate(808.000000, 263.000000)'>
            <g>
              <path d='M16.5,24c-0.1,0-0.3-0.1-0.4-0.1l-1.6-1.6l-1.6,1.6c-0.2,0.2-0.5,0.2-0.7,0l-1.6-1.6l-1.6,1.6c-0.2,0.2-0.5,0.2-0.7,0 l-1.6-1.6l-1.6,1.6c-0.2,0.2-0.5,0.2-0.7,0l-1.6-1.6l-1.6,1.6C0.7,24,0.5,24,0.3,24C0.1,23.9,0,23.7,0,23.5v-23 C0,0.3,0.1,0.1,0.3,0s0.4,0,0.5,0.1l1.6,1.6l1.6-1.6C4.3,0,4.7,0,4.9,0.1l1.6,1.6l1.6-1.6C8.3,0,8.7,0,8.9,0.1l1.6,1.6l1.6-1.6 c0.2-0.2,0.5-0.2,0.7,0l1.6,1.6l1.6-1.6C16.3,0,16.5,0,16.7,0C16.9,0.1,17,0.3,17,0.5v23c0,0.2-0.1,0.4-0.3,0.5 C16.6,24,16.6,24,16.5,24z M10.5,21c0.1,0,0.3,0,0.4,0.1l1.6,1.6l1.6-1.6c0.2-0.2,0.5-0.2,0.7,0l1.1,1.1V1.7l-1.1,1.1 c-0.2,0.2-0.5,0.2-0.7,0l-1.6-1.6l-1.6,1.6c-0.2,0.2-0.5,0.2-0.7,0L8.5,1.2L6.9,2.9C6.7,3,6.3,3,6.1,2.9L4.5,1.2L2.9,2.9C2.7,3,2.3,3,2.1,2.9L1,1.7v20.6l1.1-1.1c0.2-0.2,0.5-0.2,0.7,0l1.6,1.6l1.6-1.6c0.2-0.2,0.5-0.2,0.7,0l1.6,1.6l1.6-1.6 C10.2,21,10.4,21,10.5,21z' />
            </g>
            <g>
              <path d='M11.5,7h-8C3.2,7,3,6.8,3,6.5S3.2,6,3.5,6h8C11.8,6,12,6.2,12,6.5S11.8,7,11.5,7z' />
            </g>
            <g>
              <path d='M7.5,10h-4C3.2,10,3,9.8,3,9.5S3.2,9,3.5,9h4C7.8,9,8,9.2,8,9.5S7.8,10,7.5,10z' />
            </g>
            <g>
              <path d='M7.5,13h-4C3.2,13,3,12.8,3,12.5S3.2,12,3.5,12h4C7.8,12,8,12.2,8,12.5S7.8,13,7.5,13z' />
            </g>
            <g>
              <path d='M6.5,16h-3C3.2,16,3,15.8,3,15.5S3.2,15,3.5,15h3C6.8,15,7,15.2,7,15.5S6.8,16,6.5,16z' />
            </g>
            <g>
              <path d='M11.5,19c-0.3,0-0.5-0.2-0.5-0.5v-1.1c0-0.3,0.2-0.5,0.5-0.5s0.5,0.2,0.5,0.5v1.1C12,18.8,11.8,19,11.5,19z' />
            </g>
            <g>
              <path d='M12.5,12.1c-0.3,0-0.5-0.2-0.5-0.5v-1.1c0-0.3,0.2-0.5,0.5-0.5s0.5,0.2,0.5,0.5v1.1C13,11.9,12.8,12.1,12.5,12.1z' />
            </g>
            <g>
              <path d='M12,18c-1.1,0-2-0.9-2-2c0-0.3,0.2-0.5,0.5-0.5S11,15.7,11,16c0,0.6,0.4,1,1,1s1-0.4,1-1s-0.4-1-1-1c-1.1,0-2-0.9-2-2 c0-1.1,0.9-2,2-2s2,0.9,2,2c0,0.3-0.2,0.5-0.5,0.5S13,13.3,13,13c0-0.6-0.4-1-1-1s-1,0.4-1,1c0,0.6,0.4,1,1,1c1.1,0,2,0.9,2,2 S13.1,18,12,18z' />
            </g>
          </g>
        </g>
      </g>
    </svg>
  );
});

export default React.memo(Icon);
